<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-13 15:40:57
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-12-07 16:33:56
 * @FilePath: /wxweb-vue/Users/golden/Documents/WorkSpace/GdsWeb/goldenSalesMobile/src/views/GoodsList/index.vue
 * @Description: 分销商品列表页
-->
<template>
  <div class="page-container">
    <!-- <div class="top-bar">
      <div class="city-choice">北京</div>
      <div class="search-box">
        <van-search
          v-model="searchKey"
          placeholder="当前热搜产品"
          input-align="center"
          shape="round"
        />
      </div>
    </div> -->
    <div class="tab-list">
      <van-tabs
        v-model="activeTabName"
        swipeable
        sticky
        color="var(--tc)"
        title-active-color="var(--tc)"
        title-inactive-color="#666666"
        @change="onTabChange"
      >
        <van-tab
          v-for="(item, index) in tabList"
          swipeable
          :key="index"
          :name="item.Id"
          :title="item.Name"
          :swipe-threshold="5"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="loadError"
            :immediate-check="false"
            :offset="30"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              class="goods-item"
              v-for="(subItem, subIndex) in item.goodsList"
              :key="subIndex"
              @click="onCheckDetail(subItem.Id)"
            >
              <div class="goods-image">
                <van-image :src="subItem.imgUrl" fit="cover" />
                <span>推广赚￥{{ subItem.FirstLevelCommission }}</span>
              </div>
              <div class="goods-info">
                <p class="goods-name">{{ subItem.ShelfName }}</p>
                <p class="goods-price">
                  <span><a>￥</a>{{ subItem.ShelfPrice }}</span>
                  <span v-if="subItem.ShelfOriginPrice > subItem.ShelfPrice">
                    ￥{{ subItem.ShelfOriginPrice }}
                  </span>
                </p>
                <div class="button-box">
                  <van-button
                    color="linear-gradient(to right, #FA9B00, #FBCA39)"
                    round
                    @click.stop="
                      onCheckPoster(subItem.Id, subItem.FirstLevelCommission)
                    "
                  >
                    获取海报
                  </van-button>
                </div>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { getProductTypeList, getProductList } from "@/api/goods";

export default {
  data() {
    return {
      searchKey: "",
      loading: false,
      finished: false,
      loadError: false,
      activeTabName: "",
      tabList: [],
      pageIndex: 0,
      pageSize: 5,
    };
  },

  created() {
    this.init();
  },

  methods: {
    // 初始化
    init() {
      // 加载产品列表前5条数据
      getProductTypeList().then((res) => {
        let data = res;
        if (data instanceof Array && data.length > 0) {
          this.tabList.unshift({ Name: "全部", Id: "", goodsList: [] });
          data.map((item) => {
            if (item.Status.Id === 0) {
              // 仅显示‘已上架’的分类
              item.goodsList = [];
              this.tabList.push(item);
            }
          });
          this.getProducts();
        }
      });
    },

    // 产品列表请求方法
    getProducts() {
      getProductList({
        query: {
          type: this.activeTabName,
        },
        pager: {
          pageindex: this.pageIndex,
          pagesize: this.pageSize,
        },
      })
        .then((res) => {
          let data = res.Items;
          if (data instanceof Array) {
            data.map((item) => {
              // 产品列表图片
              const imgArr = item.Claims;
              // console.log(item.Claims)
              if (imgArr instanceof Array && imgArr.length > 0) {
                imgArr.map((subItem) => {
                  if (subItem.TypeId === 0) {
                    item.imgUrl = `${subItem.CdnUrl}/${subItem.Value}`;
                  }
                });
              }
            });
            // 添加产品数据到对应的tabList中
            this.tabList.map((item) => {
              if (item.Id === this.activeTabName) {
                if (this.pageIndex > 1) {
                  // 合并
                  item.goodsList = item.goodsList.concat(data);
                } else {
                  // 覆盖
                  item.goodsList = data;
                }
              }
            });
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true;
            }
            // 加载结束
            this.loading = false;
          }
        })
        .catch((err) => {
          // console.log(err)
          this.loadError = true;
          this.loading = false;
        });
    },

    // 上拉加载
    onLoad() {
      // console.log('上拉加载')
      this.pageIndex++;
      this.getProducts();
    },

    // tab切换
    onTabChange(val) {
      this.finished = false;
      this.loading = true;
      this.activeTabName = val;
      this.pageIndex = 0;
      this.getProducts();
    },

    // 查看产品详情
    onCheckDetail(productId) {
      this.$router.push({
        name: "GoodsDetail",
        params: { id: productId },
      });
    },

    // 获取产品海报
    onCheckPoster(productId, commission) {
      this.$router.push({
        name: "GoodsPoster",
        params: { id: productId, cs: commission },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  .top-bar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 90px;
    box-sizing: border-box;
    padding: 0 40px;
    background: #ffffff;

    .city-choice {
      position: relative;
      font-size: 36px;
      font-weight: 600;
      color: #333;
      line-height: 50px;
      padding-right: 54px;

      &::after {
        position: absolute;
        right: 0;
        top: 10px;
        z-index: 1;
        content: "";
        border: solid black;
        border-width: 0 4px 4px 0;
        display: inline-block;
        padding: 8px;
        transform: rotate(45deg);
      }
    }

    .search-box {
      flex: 1;
      max-width: 502px;
      height: 70px;

      &::v-deep .van-search {
        padding: 0;
      }
    }
  }

  .tab-list {
    // margin-top: 90px;
    margin-bottom: 100px;

    .goods-item {
      @include border-box(30px 40px);
      width: 100%;
      background: #fff;
      margin-bottom: 10px;

      .goods-image {
        position: relative;
        width: 100%;
        height: 280px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        &::v-deep .van-image {
          width: 100%;
          height: 100%;
        }

        > span {
          position: absolute;
          right: 20px;
          top: 20px;
          z-index: 1;
          padding: 0 10px;
          height: 40px;
          text-align: center;
          line-height: 44px;
          font-size: 26px;
          color: #ffffff;
          background: #ff2c55;
          box-shadow: 0px 4px 10px 0px #969696;
          border-radius: 16px;
          border: 4px solid #ffffff;
        }
      }

      .goods-info {
        position: relative;
        width: 100%;
        padding: 20px 0 0;

        .goods-name {
          margin-bottom: 22px;
          font-size: 34px;
          font-weight: 500;
          color: #333333;
          line-height: 48px;
        }

        .goods-price {
          > span:first-child {
            margin-right: 20px;
            font-size: 40px;
            font-weight: 600;
            color: #fe4600;
            line-height: 36px;

            > a {
              font-size: 26px;
            }
          }

          > span:nth-child(2) {
            font-size: 26px;
            font-weight: 400;
            color: #999999;
            line-height: 36px;
            text-decoration: line-through;
          }
        }

        .button-box {
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: 1;
          width: 200px;
          height: 76px;

          &::v-deep .van-button {
            width: 100%;
            height: 100%;

            .van-button__text {
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
</style>
